import { render, staticRenderFns } from "./ResizableAsidePanel.vue?vue&type=template&id=15457736"
import script from "./ResizableAsidePanel.vue?vue&type=script&lang=js"
export * from "./ResizableAsidePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports